module.exports = __webpack_public_path__ + "img/RECEIVE_MONEY.7a57f5ab.svg";